module.exports = __webpack_public_path__ + "img/samsung_step1.2e70e15b.png";